import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useParams, useHistory } from 'react-router-dom';
import { Button, Card, CardBody, Col, Row, Input } from 'reactstrap';
import PreloaderWidget from '../../../components/Loader';
import PageTitle from '../../../components/PageTitle';
import { delete_News, list_Internship, list_News, update_News } from '../../../helpers/actions/api.functions';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import * as FeatherIcon from 'react-feather';
import parse from 'html-react-parser';

import AddEvents from './addInternship';
import FilterButton from '../../../components/FilterButton';

const AdminInternshipDetails = () => {
    const history = useHistory();
    let userdata = localStorage.getItem('active_user') ? JSON.parse(localStorage.getItem('active_user')) : null;
    const param = useParams();
    const [data, setData] = useState({});
    const [isActive, setIsActive] = useState(true);
    const [modalb, setModalb] = useState(false);
    // const [view, setView] = useState(false);

    // const toggleb = () => setModalb(!modalb);
    const handleClose = () => {
        setModalb(false);
    };
    const getNews = () => {
        setIsActive(true);
        list_Internship()
            .then((res) => {
                setIsActive(false);
                setData(res.data.filter((sc) => sc.id == param.id)[0]);
            })
            .catch((err) => {
                setIsActive(false);
                toast.error(err.response.data.message);
            });
    };

    const sizePerPageRenderer = ({ options, currSizePerPage, onSizePerPageChange }) => (
        <React.Fragment>
            <label className="d-inline mr-1">Show</label>
            <Input
                type="select"
                name="select"
                id="no-entries"
                className="custom-select custom-select-sm d-inline col-1"
                defaultValue={currSizePerPage}
                onChange={(e) => onSizePerPageChange(e.target.value)}>
                {options.map((option, idx) => {
                    return <option key={idx}>{option.text}</option>;
                })}
            </Input>
            <label className="d-inline ml-1">entries</label>
        </React.Fragment>
    );
    const defaultSorted = [
        {
            dataField: 'id',
            order: 'desc',
        },
    ];
    const columns = [
        {
            dataField: 'title',
            text: 'Title',
            sort: true,
            formatter: (rowContent) => {
                return <div className="text-capitalize">Yuva Bootcamp</div>;
            },
        },
        {
            dataField: 'end_date',
            text: 'Date',
            sort: true,
            formatter: (rowContent) => {
                return <div className="text-capitalize">12-01-2023</div>;
            },
        },

        {
            dataField: 'description',
            text: 'Description',
            sort: true,
            formatter: (rowContent) => {
                return <div className="text-capitalize">News Description goes here</div>;
            },
        },
    ];

    useEffect(() => {
        getNews();
    }, [param.id]);

    // const listData = (id) => {
    //     incubatee_details(id)
    //         .then((res) => {
    //             setData(res.result);
    //             setIsActive(false);
    //         })
    //         .catch((err) => {
    //             setIsActive(false);
    //             toast.error(err.response.data.message);
    //         });
    // };
    if (isActive) {
        return <PreloaderWidget />;
    }
    const handleSubmitNews = (d) => {
        console.log(d);
        let payload = new FormData();
        Object.keys(d).map((key) => {
            payload.append(key, d[key]);
        });
        update_News(param.id, payload)
            .then((res) => {
                setIsActive(false);
                toast.success(res.message);
                getNews();

                setModalb(!modalb);
            })
            .catch((err) => {
                setIsActive(false);
                toast.error(err.response.message);
            });
    };

    const openFile = (file) => {
        if (file) {
            window.open(file, '_blank');
        }
    };
    const deleteNews = () => {
        setIsActive(true);
        delete_News(param.id)
            .then((res) => {
                setIsActive(false);
                toast.success(res.message);
                history.push('/news-list');
                // listData(param.id);
            })
            .catch((err) => {
                setIsActive(false);
                toast.error(err.response.data.message);
            });
    };

    return (
        <React.Fragment>
            <Row className="page-title">
                <Col md={12}>
                    <PageTitle
                        breadCrumbItems={[
                            { label: 'Internship List', path: '/internship-list' },
                            { label: 'Details', path: '/Internship-detail', active: true },
                        ]}
                        title="Internship Details"
                    />
                </Col>
            </Row>
            {/* <Row>
                <Col md={12} className="d-flex justify-content-center m-3">
                    <FilterButton
                        btnname="View Details"
                        style={{ backgroundColor: '#2eb82e' }}
                        onClick={() => {
                            setView(false);
                        }}
                    />
                    <FilterButton
                        btnname="View Bookings"
                        style={{ backgroundColor: '#e600e6' }}
                        onClick={() => {
                            setView(true);
                        }}
                    />
                </Col>
            </Row> */}
            {/* /////////////////////////////////// */}

            <Row>
                <Col md={6} xl={12} className="mx-auto">
                    <Card>
                        <CardBody className="pb-0">
                            <div className="mt-3 pt-2 ">
                                {/* <h4 className="mb-3 font-size-15">Detailed  Information</h4> */}
                                <div className="table-responsive incu-detail">
                                    <table className="table  table-striped  text-muted">
                                        <tbody className="">
                                            <tr>
                                                <th scope="row">Title</th>
                                                <td className="text-capitalize">{data?.title}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Date</th>
                                                {/* <td className="text-capitalize">{data?.end_date}</td> */}
                                                {/* <td>{data?.end_date ? new Date(data.end_date).toLocaleDateString() : '-'}</td> */}
                                                <td>
                                                    {data?.end_date
                                                        ? (() => {
                                                              const date = new Date(data.end_date);
                                                              const day = String(date.getDate()).padStart(2, '0');
                                                              const month = String(date.getMonth() + 1).padStart(
                                                                  2,
                                                                  '0'
                                                              );
                                                              const year = date.getFullYear();
                                                              return `${day}-${month}-${year}`;
                                                          })()
                                                        : '-'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Description</th>
                                                <td className="">
                                                    {data?.description && parse(data?.description)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Organisation</th>
                                                <td className="text-capitalize">
                                                    {data?.organisation && parse(data?.organisation)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <br />
                                </div>
                            </div>
                            {/* <div className="mt-3 pt-2 border-top">
                            <h4 className="mb-3 font-size-15">Skills</h4>
                            <label className="badge badge-soft-primary mr-1">UI design</label>
                            <label className="badge badge-soft-primary mr-1">UX</label>
                            <label className="badge badge-soft-primary mr-1">Sketch</label>
                            <label className="badge badge-soft-primary mr-1">Photoshop</label>
                            <label className="badge badge-soft-primary mr-1">Frontend</label>
                        </div> */}
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* /////////////////////////////////// */}

            {/* ////////////////////////////////// */}

            {/* ////////////////////////////////// */}
            {modalb && (
                <AddEvents
                    open={modalb}
                    handleClose={handleClose}
                    edit={true}
                    handleApply={handleSubmitNews}
                    data={{
                        title: data?.title,
                        date: data?.date,
                        designation: data?.designation,
                        photo: data?.photo,
                    }}
                />
            )}
        </React.Fragment>
    );
};

export default AdminInternshipDetails;
